/**
 * Throw an error asynchronously.
 * This is useful in cases where the code can recover from an error but you still want it thrown.
 * @param error - The error to throw.
 */
export default function throwAsync(error: Error): void {
    setTimeout(() => {
        throw error;
    });
}
